import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import "../styles/LoginPage.scss";

const credentials = [
  { username: "dev", password: "4843" },
  { username: "admin", password: "48434843" },
];

function LoginPage() {
  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [wrongPass, setWrongPass] = useState(false);
  const [showSlider, setShowSlider] = useState(false);
  const [sliderValue, setSliderValue] = useState(1);
  const navigate = useNavigate();

  const isFilled = username.trim() !== "" && password.trim() !== "";

  const handleArrowClick = () => {
    const found = credentials.find(
      cred => cred.username === username && cred.password === password
    );
    if (found) {
      sessionStorage.setItem("isLoggedIn", "true");
      setShowSlider(true);
      let value = 1;
      const interval = setInterval(() => {
        setSliderValue(value);
        value++;
        if (value > 100) {
            clearInterval(interval);
            setTimeout(() => navigate("/"), 500);
        }
        }, 50); 
    } else {
      setWrongPass(true);
      setTimeout(() => setWrongPass(false), 1500);
    }
  };

  return (
    <div className="container">
      <div className="card">
        <img src="/logo.png" alt="Logo" className="logo" />
        {showSlider && (
          <div className="number-slider">
            <div key={sliderValue} className="slider-number">
              {sliderValue}
            </div>
          </div>
        )}
        {!showSlider && (
          <div className={`input-group${showSlider ? " fade-out" : ""}`}>
            <div className="input-icon">
              <input
                type="text"
                className="input"
                autoComplete="off"
                value={username}
                onChange={e => setUsername(e.target.value)}
                // placeholder="Username"
              />
              <img src="/U.png" alt="U icon" className="icon-img" />
            </div>
            <div className="input-icon">
              <img src="/P.png" alt="P icon" className="icon-img" />
              <input
                type="password"
                className="input"
                value={password}
                onChange={e => setPassword(e.target.value)}
                // placeholder="Password"
              />
            </div>
          </div>
        )}
        {!showSlider && (
            <div className="arrowButtonContainer">
                <div className="arrow-relative">
                    {isFilled && !wrongPass ? (
                    <button className="arrow-button" onClick={handleArrowClick}>
                        <img src="/arrow-green.png" alt="Sign In" className="arrow-icon" />
                    </button>
                    ) : (
                    <span style={{ width: 40, height: 40, display: "inline-block" }}></span>
                    )}
                    {wrongPass && (
                    <img
                        src="/wrongpasscodeicon.png"
                        alt="Wrong Password"
                        className="wrongpass-icon fade-in-out"
                    />
                    )}
                </div>
            </div>
        )}
        <div className="copyright">
         © 2025 loco motiv, Inc. All rights reserved. The application is Islamic shariah compliant.
        </div>
      </div>
    </div>
  );
}

export default LoginPage;